(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wbs-ugc-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    /**
     * This theme (WBS / Apollo-style ajax cart) refreshes the slideout drawer and `.js-cart-count`
     * via `Shopify.theme.ajaxCart.updateView` — not via `cart:update` listeners in theme.js.
     * Same pattern as `snippets/wbs-fbt.liquid` `refreshLegacyCartUi`.
     */
    const refreshLegacyCartUi = (cart) => {
      try {
        if (!cart) return;
        const configEl = document.getElementById('cart-config');
        const config = configEl ? JSON.parse(configEl.textContent || '{}') : null;
        const updater = window.Shopify?.theme?.ajaxCart?.updateView;
        if (typeof updater === 'function' && config) {
          updater(config, cart);
        }
        const miniCart = window?.theme?.miniCart || window?.Shopify?.theme?.miniCart;
        if (miniCart) {
          if (typeof miniCart.updateElements === 'function') miniCart.updateElements();
          if (typeof miniCart.generateCart === 'function') miniCart.generateCart();
        }
        document.querySelectorAll('.js-cart-count').forEach((el) => {
          el.textContent = String(cart.item_count ?? 0);
        });
      } catch (_) {}
    };

    const sections = document.querySelectorAll('.ugc-video-carousel-section');
    sections.forEach((section) => {
      const payloadNode = section.querySelector('[data-carousel-payload]');
      if (!payloadNode) return;

      let slides = [];
      try {
        slides = JSON.parse(payloadNode.textContent.trim());
      } catch (error) {
        return;
      }
      if (!slides.length) return;

      const track = section.querySelector('[data-carousel-track]');
      const carouselPrevButtons = Array.from(
        section.querySelectorAll(
          '.ugc-video-carousel__heading-nav .slideshow-control--previous, .ugc-video-carousel__viewport-wrap .slideshow-control--previous'
        )
      );
      const carouselNextButtons = Array.from(
        section.querySelectorAll(
          '.ugc-video-carousel__heading-nav .slideshow-control--next, .ugc-video-carousel__viewport-wrap .slideshow-control--next'
        )
      );
      const items = Array.from(section.querySelectorAll('[data-carousel-item]'));
      const sliderVideos = Array.from(section.querySelectorAll('.ugc-video-carousel__video'));
      const modal = section.querySelector('[data-modal]');
      const modalPrevButton = modal.querySelector('[data-modal-prev]');
      const modalNextButton = modal.querySelector('[data-modal-next]');
      const modalVideo = modal.querySelector('[data-modal-video]');
      const progress = modal.querySelector('[data-progress]');
      const indexIndicator = modal.querySelector('[data-index-indicator]');
      const playPause = modal.querySelector('[data-play-pause]');
      const muteToggle = modal.querySelector('[data-mute-toggle]');
      const videoToggleButton = modal.querySelector('[data-video-toggle]');
      const statusNode = modal.querySelector('[data-status]');
      const openDrawerButtons = Array.from(modal.querySelectorAll('[data-open-drawer]'));
      const closeDrawerButton = modal.querySelector('[data-close-drawer]');
      const mobileDrawer = modal.querySelector('[data-mobile-drawer]');
      const addToCartDesktop = modal.querySelector('[data-add-to-cart]');
      const addToCartMobile = modal.querySelector('[data-add-to-cart-mobile]');
      const desktopVariantPicker = modal.querySelector('[data-variant-picker]');
      const mobileVariantPicker = modal.querySelector('[data-variant-picker-mobile]');
      const addToCartLabelDefault =
        addToCartDesktop?.textContent?.trim() || addToCartMobile?.textContent?.trim() || 'Add to cart';
      const addToCartAddingLabel = section.dataset.addToCartAddingLabel || 'Adding';
      const addToCartAddedLabel = section.dataset.addToCartAddedLabel || 'Added';
      const ADD_TO_CART_ADDED_RESET_MS = 3000;
      let addToCartInFlight = false;
      let addToCartJustAdded = false;
      let addToCartResetTimer = null;
      let currentIndex = 0;
      let selectedVariantId = null;
      let previousBodyOverflow = '';
      let previousHtmlOverflow = '';
      let sliderObserver = null;
      let hoverHandlers = [];
      let sliderClickHandlers = [];
      let statusClearTimer = null;
      const STATUS_AUTO_CLEAR_MS = 4000;
      const cancelStatusClearTimer = () => {
        if (statusClearTimer) {
          clearTimeout(statusClearTimer);
          statusClearTimer = null;
        }
      };
      const scheduleStatusClear = (snapshotMessage) => {
        cancelStatusClearTimer();
        if (!statusNode || !snapshotMessage) return;
        statusClearTimer = setTimeout(() => {
          statusClearTimer = null;
          if (statusNode && statusNode.textContent === snapshotMessage) statusNode.textContent = '';
        }, STATUS_AUTO_CLEAR_MS);
      };
      const cancelAddToCartResetTimer = () => {
        if (addToCartResetTimer) {
          clearTimeout(addToCartResetTimer);
          addToCartResetTimer = null;
        }
      };
      const clearAddToCartSuccessState = () => {
        cancelAddToCartResetTimer();
        addToCartJustAdded = false;
      };
      const scheduleAddToCartReset = () => {
        cancelAddToCartResetTimer();
        addToCartResetTimer = setTimeout(() => {
          addToCartResetTimer = null;
          addToCartJustAdded = false;
          syncAddToCartButtons();
        }, ADD_TO_CART_ADDED_RESET_MS);
      };
      const ICON_PLAY =
        '<svg viewBox="0 0 512 512" width="20px" height="20px" aria-hidden="true"><path d="M176 480C148.6 480 128 457.6 128 432v-352c0-25.38 20.4-47.98 48.01-47.98c8.686 0 17.35 2.352 25.02 7.031l288 176C503.3 223.8 512 239.3 512 256s-8.703 32.23-22.97 40.95l-288 176C193.4 477.6 184.7 480 176 480z"></path></svg>';
      const ICON_PAUSE =
        '<svg viewBox="0 0 320 512" width="20px" height="20px" aria-hidden="true"><path d="M272 63.1l-32 0c-26.51 0-48 21.49-48 47.1v288c0 26.51 21.49 48 48 48L272 448c26.51 0 48-21.49 48-48v-288C320 85.49 298.5 63.1 272 63.1zM80 63.1l-32 0c-26.51 0-48 21.49-48 48v288C0 426.5 21.49 448 48 448l32 0c26.51 0 48-21.49 48-48v-288C128 85.49 106.5 63.1 80 63.1z"></path></svg>';
      const ICON_MUTE =
        '<svg viewBox="0 0 640 512" width="20px" height="20px" aria-hidden="true"><path d="M533.6 32.5C598.5 85.2 640 165.8 640 256s-41.5 170.7-106.4 223.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C557.5 398.2 592 331.2 592 256s-34.5-142.2-88.7-186.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM473.1 107c43.2 35.2 70.9 88.9 70.9 149s-27.7 113.8-70.9 149c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C475.3 341.3 496 301.1 496 256s-20.7-85.3-53.2-111.8c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zm-60.5 74.5C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM301.1 34.8C312.6 40 320 51.4 320 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3z"></path></svg>';
      const ICON_UNMUTE =
        '<svg viewBox="0 0 576 512" width="20px" height="20px" aria-hidden="true"><path d="M301.1 34.8C312.6 40 320 51.4 320 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zM425 167l55 55 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55 55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55-55 55c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l55-55-55-55c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"></path></svg>';

      const getCarouselPlayMode = () => section.dataset.carouselVideoPlay;
      const getModalPlayMode = () => section.dataset.modalVideoPlay;
      const isLoopEnabled = () => section.dataset.videoLoopEnabled === 'true';
      const isDesktop = () => window.matchMedia('(min-width: 990px)').matches;
      const escapeHtml = (text) => {
        const div = document.createElement('div');
        div.textContent = text || '';
        return div.innerHTML;
      };

      const renderImage = (url) => (url ? `<img src="${url}" alt="" loading="lazy">` : '');

      const clearCarouselPlaybackBehavior = () => {
        if (sliderObserver) {
          sliderObserver.disconnect();
          sliderObserver = null;
        }
        hoverHandlers.forEach(({ video, enter, leave }) => {
          video.removeEventListener('mouseenter', enter);
          video.removeEventListener('mouseleave', leave);
        });
        hoverHandlers = [];
        sliderClickHandlers.forEach(({ video, click }) => {
          video.removeEventListener('click', click);
        });
        sliderClickHandlers = [];
      };

      const applyLoopSetting = () => {
        sliderVideos.forEach((video) => {
          video.loop = isLoopEnabled();
          video.muted = true;
          video.playsInline = true;
        });
        modalVideo.loop = isLoopEnabled();
      };

      const pauseAllSliderVideos = (exceptVideo = null) => {
        sliderVideos.forEach((video) => {
          if (exceptVideo && video === exceptVideo) return;
          video.pause();
          const item = video.closest('[data-carousel-item]');
          if (item) item.setAttribute('data-paused', 'true');
        });
      };

      const setupCarouselPlaybackBehavior = () => {
        clearCarouselPlaybackBehavior();
        applyLoopSetting();
        const mode = getCarouselPlayMode();

        if (mode === 'autoplay' || mode === 'autoplay_in_viewport') {
          sliderVideos.forEach((video) => {
            video.pause();
            const item = video.closest('[data-carousel-item]');
            if (item) item.setAttribute('data-paused', 'true');
          });
          sliderObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                const video = entry.target;
                if (entry.isIntersecting && entry.intersectionRatio >= 0.98) {
                  video
                    .play()
                    .then(() => {
                      const item = video.closest('[data-carousel-item]');
                      if (item) item.setAttribute('data-paused', 'false');
                    })
                    .catch(() => {
                      const item = video.closest('[data-carousel-item]');
                      if (item) item.setAttribute('data-paused', 'true');
                    });
                } else {
                  video.pause();
                  const item = video.closest('[data-carousel-item]');
                  if (item) item.setAttribute('data-paused', 'true');
                }
              });
            },
            { root: track, threshold: [0, 0.98, 1] }
          );

          sliderVideos.forEach((video) => sliderObserver.observe(video));
          return;
        }

        if (mode === 'play_on_hover') {
          sliderVideos.forEach((video) => {
            video.pause();
            const item = video.closest('[data-carousel-item]');
            if (item) item.setAttribute('data-paused', 'true');
            const enter = () => {
              video
                .play()
                .then(() => {
                  const videoItem = video.closest('[data-carousel-item]');
                  if (videoItem) videoItem.setAttribute('data-paused', 'false');
                })
                .catch(() => {
                  const videoItem = video.closest('[data-carousel-item]');
                  if (videoItem) videoItem.setAttribute('data-paused', 'true');
                });
            };
            const leave = () => {
              video.pause();
              const videoItem = video.closest('[data-carousel-item]');
              if (videoItem) videoItem.setAttribute('data-paused', 'true');
            };
            video.addEventListener('mouseenter', enter);
            video.addEventListener('mouseleave', leave);
            hoverHandlers.push({ video, enter, leave });
          });
          return;
        }

        if (mode === 'click_to_play') {
          sliderVideos.forEach((video) => {
            video.pause();
            const item = video.closest('[data-carousel-item]');
            if (item) item.setAttribute('data-paused', 'true');
            const click = (event) => {
              event.stopPropagation();
              if (video.paused) {
                pauseAllSliderVideos(video);
                video
                  .play()
                  .then(() => {
                    const videoItem = video.closest('[data-carousel-item]');
                    if (videoItem) videoItem.setAttribute('data-paused', 'false');
                  })
                  .catch(() => {
                    const videoItem = video.closest('[data-carousel-item]');
                    if (videoItem) videoItem.setAttribute('data-paused', 'true');
                  });
              } else {
                video.pause();
                const videoItem = video.closest('[data-carousel-item]');
                if (videoItem) videoItem.setAttribute('data-paused', 'true');
              }
            };
            video.addEventListener('click', click);
            sliderClickHandlers.push({ video, click });
          });
          return;
        }

        sliderVideos.forEach((video) => {
          video.pause();
          const item = video.closest('[data-carousel-item]');
          if (item) item.setAttribute('data-paused', 'true');
        });
      };

      const getPriceTargets = () => [
        modal.querySelector('[data-strip-price]'),
        modal.querySelector('[data-drawer-price]'),
        modal.querySelector('[data-drawer-price-mobile]'),
      ];
      const getCompareTargets = () => [
        modal.querySelector('[data-strip-compare]'),
        modal.querySelector('[data-drawer-compare]'),
        modal.querySelector('[data-drawer-compare-mobile]'),
      ];

      const setPriceUI = (price, compareAtPrice) => {
        getPriceTargets().forEach((node) => {
          if (node) node.innerHTML = price || '';
        });
        getCompareTargets().forEach((node) => {
          if (!node) return;
          node.innerHTML = compareAtPrice || '';
          node.style.display = compareAtPrice ? 'inline' : 'none';
        });
      };

      const setProductUI = (product) => {
        const titleTargets = [
          modal.querySelector('[data-strip-title]'),
          modal.querySelector('[data-drawer-title]'),
          modal.querySelector('[data-drawer-title-mobile]'),
        ];
        const imageTargets = [
          modal.querySelector('[data-strip-image]'),
          modal.querySelector('[data-drawer-image]'),
          modal.querySelector('[data-drawer-image-mobile]'),
        ];
        const descriptionTargets = [
          modal.querySelector('[data-drawer-description]'),
          modal.querySelector('[data-drawer-description-mobile]'),
        ];
        const linkTargets = [
          modal.querySelector('[data-drawer-header-thumb-link]'),
          modal.querySelector('[data-drawer-header-title-link]'),
          modal.querySelector('[data-drawer-header-thumb-link-mobile]'),
          modal.querySelector('[data-drawer-header-title-link-mobile]'),
        ];

        titleTargets.forEach((node) => {
          if (node) node.textContent = product?.title || '';
        });
        setPriceUI(product?.price, product?.compareAtPrice);
        imageTargets.forEach((node) => {
          if (!node) return;
          node.innerHTML = renderImage(product?.image);
        });
        descriptionTargets.forEach((node) => {
          if (!node) return;
          node.innerHTML = product?.description || '';
          const details = node.closest('.ugc-video-modal__description');
          if (!details) return;
          const hasText = Boolean(node.textContent?.replace(/\u00a0/g, ' ').trim());
          details.hidden = !hasText;
        });
        linkTargets.forEach((node) => {
          if (!node) return;
          node.href = product?.url || '#';
        });
      };

      const syncAddToCartButtons = () => {
        const hasVariant = Boolean(selectedVariantId);
        let label = addToCartLabelDefault;
        if (addToCartInFlight) {
          label = addToCartAddingLabel;
        } else if (addToCartJustAdded) {
          label = addToCartAddedLabel;
        }
        if (hasVariant && statusNode?.textContent === 'Select a variant') {
          cancelStatusClearTimer();
          statusNode.textContent = '';
        }
        [addToCartDesktop, addToCartMobile].forEach((btn) => {
          if (!btn) return;
          btn.textContent = label;
          btn.disabled = addToCartInFlight || !hasVariant;
          btn.setAttribute('aria-busy', addToCartInFlight ? 'true' : 'false');
        });
      };

      const renderVariants = (product) => {
        const optionNames = product?.optionNames || [];
        const variants = product?.variants || [];
        const applyVariantPrice = (variant) => {
          setPriceUI(
            variant?.price || product?.price,
            variant?.compareAtPrice ?? (variant ? null : product?.compareAtPrice)
          );
        };
        if (desktopVariantPicker) desktopVariantPicker.innerHTML = '';
        if (mobileVariantPicker) mobileVariantPicker.innerHTML = '';
        if (!variants.length) {
          selectedVariantId = null;
          applyVariantPrice(null);
          syncAddToCartButtons();
          return;
        }
        if (!optionNames.length) {
          const autoVariant = variants.find((variant) => variant.available) || variants[0];
          selectedVariantId = autoVariant?.id || null;
          applyVariantPrice(autoVariant);
          syncAddToCartButtons();
          return;
        }

        const getFirstAvailableVariant = () => variants.find((variant) => variant.available) || variants[0];
        let selectedVariant =
          variants.find((variant) => String(variant.id) === String(selectedVariantId)) || getFirstAvailableVariant();
        let selectedOptions = Array.isArray(selectedVariant?.options) ? [...selectedVariant.options] : [];

        const findMatchingVariant = (optionsArray) => {
          return variants.find((variant) => {
            return optionNames.every((_, index) => variant.options?.[index] === optionsArray[index]);
          });
        };

        const isOptionValueAvailable = (optionIndex, optionValue) => {
          return variants.some((variant) => {
            if (!variant.available) return false;
            if (variant.options?.[optionIndex] !== optionValue) return false;
            return optionNames.every((_, index) => {
              if (index === optionIndex) return true;
              return variant.options?.[index] === selectedOptions[index];
            });
          });
        };

        const renderPicker = (container) => {
          if (!container) return;
          container.innerHTML = '';

          optionNames.forEach((optionName, optionIndex) => {
            const group = document.createElement('div');
            group.className = 'ugc-video-modal__variant-group';

            const label = document.createElement('p');
            label.className = 'ugc-video-modal__variant-group-label';
            label.textContent = optionName;
            group.appendChild(label);

            const valuesWrap = document.createElement('div');
            valuesWrap.className = 'ugc-video-modal__variant-group-values';

            const uniqueValues = [
              ...new Set(variants.map((variant) => variant.options?.[optionIndex]).filter(Boolean)),
            ];
            uniqueValues.forEach((optionValue) => {
              const button = document.createElement('button');
              button.type = 'button';
              button.className = 'ugc-video-modal__variant';
              button.textContent = optionValue;
              const isSelected = selectedOptions[optionIndex] === optionValue;
              const isAvailable = isOptionValueAvailable(optionIndex, optionValue);
              button.classList.toggle('is-active', isSelected);
              button.disabled = !isAvailable;
              button.addEventListener('click', () => {
                selectedOptions[optionIndex] = optionValue;
                const exactMatch = findMatchingVariant(selectedOptions);
                if (exactMatch) {
                  selectedVariant = exactMatch;
                } else {
                  const fallbackMatch = variants.find((variant) => {
                    if (!variant.available) return false;
                    return optionNames.every((_, index) => variant.options?.[index] === selectedOptions[index]);
                  });
                  if (fallbackMatch) selectedVariant = fallbackMatch;
                }
                selectedVariantId = selectedVariant?.id || null;
                selectedOptions = Array.isArray(selectedVariant?.options)
                  ? [...selectedVariant.options]
                  : selectedOptions;
                applyVariantPrice(selectedVariant);
                renderPicker(desktopVariantPicker);
                renderPicker(mobileVariantPicker);
                syncAddToCartButtons();
              });
              valuesWrap.appendChild(button);
            });

            group.appendChild(valuesWrap);
            container.appendChild(group);
          });
        };

        selectedVariantId = selectedVariant?.id || null;
        applyVariantPrice(selectedVariant);
        renderPicker(desktopVariantPicker);
        renderPicker(mobileVariantPicker);
        syncAddToCartButtons();
      };

      const syncButtons = () => {
        playPause.innerHTML = modalVideo.paused ? ICON_PLAY : ICON_PAUSE;
        playPause.setAttribute('aria-label', modalVideo.paused ? 'Play' : 'Pause');
        muteToggle.innerHTML = modalVideo.muted ? ICON_UNMUTE : ICON_MUTE;
        muteToggle.setAttribute('aria-label', modalVideo.muted ? 'Unmute' : 'Mute');
      };

      const updateProgress = () => {
        if (!modalVideo.duration || Number.isNaN(modalVideo.duration)) {
          progress.value = 0;
          return;
        }
        progress.value = String((modalVideo.currentTime / modalVideo.duration) * 100);
      };

      const updateModalNavState = () => {
        const isFirst = currentIndex <= 0;
        const isLast = currentIndex >= slides.length - 1;
        if (modalPrevButton) {
          modalPrevButton.disabled = isFirst;
          modalPrevButton.setAttribute('aria-disabled', String(isFirst));
        }
        if (modalNextButton) {
          modalNextButton.disabled = isLast;
          modalNextButton.setAttribute('aria-disabled', String(isLast));
        }
      };

      const updateCarouselNavState = () => {
        if (!track) return;
        const maxScrollLeft = Math.max(0, track.scrollWidth - track.clientWidth);
        const atStart = track.scrollLeft <= 1;
        const atEnd = track.scrollLeft >= maxScrollLeft - 1;
        carouselPrevButtons.forEach((button) => {
          button.disabled = atStart;
          button.setAttribute('aria-disabled', String(atStart));
        });
        carouselNextButtons.forEach((button) => {
          button.disabled = atEnd;
          button.setAttribute('aria-disabled', String(atEnd));
        });
      };

      const setSlide = (index, autoplay = true) => {
        if (!slides[index]) return;
        currentIndex = index;
        const slide = slides[currentIndex];
        indexIndicator.textContent = `${currentIndex + 1}/${slides.length}`;
        modalVideo.src = slide.videoUrl || '';
        modalVideo.poster = slide.poster || '';
        modalVideo.currentTime = 0;
        modalVideo.muted = true;
        progress.value = 0;
        addToCartInFlight = false;
        clearAddToCartSuccessState();
        cancelStatusClearTimer();
        if (statusNode) statusNode.textContent = '';
        setProductUI(slide.product);
        renderVariants(slide.product);
        syncButtons();
        updateModalNavState();
        if (autoplay && slide.videoUrl && getModalPlayMode() === 'autoplay') {
          modalVideo.play().catch(() => {});
        }
      };

      const openModal = (index) => {
        setSlide(index);
        if (!modal.open) {
          previousBodyOverflow = document.body.style.overflow;
          previousHtmlOverflow = document.documentElement.style.overflow;
          document.body.style.overflow = 'hidden';
          document.documentElement.style.overflow = 'hidden';
          modal.showModal();
        }
        if (getModalPlayMode() === 'play_on_hover') {
          modalVideo.pause();
        }
      };

      const closeModal = () => {
        addToCartInFlight = false;
        clearAddToCartSuccessState();
        modalVideo.pause();
        if (mobileDrawer) mobileDrawer.classList.remove('is-open');
        document.body.style.overflow = previousBodyOverflow;
        document.documentElement.style.overflow = previousHtmlOverflow;
        modal.close();
        syncAddToCartButtons();
        cancelStatusClearTimer();
        if (statusNode) statusNode.textContent = '';
      };

      const goPrev = () => {
        if (currentIndex <= 0) return;
        setSlide(currentIndex - 1);
      };
      const goNext = () => {
        if (currentIndex >= slides.length - 1) return;
        setSlide(currentIndex + 1);
      };

      items.forEach((item, index) => {
        item.addEventListener('click', (event) => {
          if (getCarouselPlayMode() === 'click_to_play' && event.target.closest('.ugc-video-carousel__video')) return;
          openModal(index);
        });
      });

      setupCarouselPlaybackBehavior();
      updateCarouselNavState();
      track?.addEventListener('scroll', updateCarouselNavState, { passive: true });
      window.addEventListener('resize', () => {
        updateCarouselNavState();
        setupCarouselPlaybackBehavior();
      });

      carouselPrevButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          track.scrollBy({ left: -320, behavior: 'smooth' });
        });
      });
      carouselNextButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          track.scrollBy({ left: 320, behavior: 'smooth' });
        });
      });
      modal.querySelector('[data-modal-close]').addEventListener('click', closeModal);
      modalPrevButton?.addEventListener('click', goPrev);
      modalNextButton?.addEventListener('click', goNext);
      videoToggleButton?.addEventListener('click', () => {
        if (modalVideo.paused) modalVideo.play();
        else modalVideo.pause();
      });
      videoToggleButton?.addEventListener('mouseenter', () => {
        if (getModalPlayMode() === 'play_on_hover') {
          modalVideo.play().catch(() => {});
        }
      });
      videoToggleButton?.addEventListener('mouseleave', () => {
        if (getModalPlayMode() === 'play_on_hover') {
          modalVideo.pause();
        }
      });
      playPause.addEventListener('click', () => {
        if (modalVideo.paused) modalVideo.play();
        else modalVideo.pause();
      });
      muteToggle.addEventListener('click', () => {
        modalVideo.muted = !modalVideo.muted;
        syncButtons();
      });
      progress.addEventListener('input', () => {
        if (!modalVideo.duration || Number.isNaN(modalVideo.duration)) return;
        const pct = Number(progress.value) / 100;
        modalVideo.currentTime = modalVideo.duration * pct;
      });
      modalVideo.addEventListener('timeupdate', updateProgress);
      modalVideo.addEventListener('play', syncButtons);
      modalVideo.addEventListener('pause', syncButtons);
      modal.addEventListener('click', (event) => {
        if (event.target === modal) closeModal();
      });

      openDrawerButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (isDesktop()) return;
          mobileDrawer?.classList.add('is-open');
        });
      });
      const mobileBottom = modal.querySelector('[data-mobile-bottom]');
      mobileBottom?.addEventListener('click', (event) => {
        if (isDesktop()) return;
        if (event.target.closest('a[href]')) return;
        mobileDrawer?.classList.add('is-open');
      });
      closeDrawerButton?.addEventListener('click', () => {
        mobileDrawer.classList.remove('is-open');
      });
      mobileDrawer?.addEventListener('click', (event) => {
        if (event.target === mobileDrawer) mobileDrawer.classList.remove('is-open');
      });

      /**
       * Lets the storefront cart UI refresh without importing theme JS.
       * Fetches `/cart.js`, then dispatches `cart:update` with the same `detail` shape as this theme’s
       * CartAddEvent (`detail.resource`, `detail.sourceId`, `detail.data.itemCount`, …).
       * Also fires `cart:updated` / `cart:refresh` (common optional listeners) with `{ cart }`.
       */
      const publishCartUpdateAfterAdd = async () => {
        let cart = null;
        try {
          const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
          if (res.ok) cart = await res.json();
        } catch (_) {}

        refreshLegacyCartUi(cart);

        const itemCount = cart?.item_count ?? 0;
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: section.id || 'ugc-video-carousel',
              data: {
                source: 'ugc-video-carousel',
                itemCount,
                variantId: selectedVariantId ? String(selectedVariantId) : undefined,
              },
            },
          })
        );
        if (cart) {
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart } }));
        }
      };

      const addToCart = async () => {
        if (!selectedVariantId) {
          if (statusNode) statusNode.textContent = 'Select a variant';
          scheduleStatusClear('Select a variant');
          return;
        }
        clearAddToCartSuccessState();
        addToCartInFlight = true;
        syncAddToCartButtons();
        cancelStatusClearTimer();
        if (statusNode) statusNode.textContent = '';
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: Number(selectedVariantId), quantity: 1 }),
          });
          if (!response.ok) throw new Error('Request failed');
          await publishCartUpdateAfterAdd();
          cancelStatusClearTimer();
          if (statusNode) statusNode.textContent = '';
          addToCartJustAdded = true;
          scheduleAddToCartReset();
        } catch (error) {
          if (statusNode) statusNode.textContent = 'Could not add to cart';
          scheduleStatusClear('Could not add to cart');
        } finally {
          addToCartInFlight = false;
          syncAddToCartButtons();
        }
      };

      addToCartDesktop?.addEventListener('click', addToCart);
      addToCartMobile?.addEventListener('click', addToCart);
      syncAddToCartButtons();

      document.addEventListener('keydown', (event) => {
        if (!modal.open) return;
        if (event.key === 'ArrowLeft') goPrev();
        if (event.key === 'ArrowRight') goNext();
        if (event.key === 'Escape') closeModal();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
